import styled from "styled-components";

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    align-items: flex-end;
    align-self: flex-start;
    margin-right: 8px;
    margin-top: 2px;
    vertical-align: baseline;
  }

  @media (max-width: 768px) {
    align-items: flex-start;
  }

  @media screen and (max-width: 425px) {
    padding-left: 0;
  }
`;
